import { render, staticRenderFns } from "./occupy-order-detail.vue?vue&type=template&id=19108888&scoped=true"
import script from "./occupy-order-detail.vue?vue&type=script&lang=js"
export * from "./occupy-order-detail.vue?vue&type=script&lang=js"
import style0 from "./occupy-order-detail.vue?vue&type=style&index=0&id=19108888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19108888",
  null
  
)

export default component.exports